// @flow

import React, { useContext } from "react";
import { localize, context } from "redux-i18n";
import { Button, Col, Label, TooltipDropdown, Icon, Icons, ComboBox } from "@components";
import type { FormProps } from "@rjsf/core";
import classNames from "classnames";

export function MultiSelectField(props: FormProps) {
  const schemaItems = props.schema?.items;
  const type = schemaItems?.type;
  const defaultItems = schemaItems?.oneOf || schemaItems?.properties?.id?.oneOf || [];
  const options = defaultItems.map(item => ({
    value: item.const,
    label: item.title,
  }));

  function selected() {
    if (!props.formData) {
      return [];
    }

    return props.formData.map(item => {
      const option = defaultItems.find(el =>
        type === "object" ? el.const === item.id : el.const === item,
      );
      return {
        value: option?.const || option,
        label: option?.title || option,
      };
    });
  }

  function handleChange(items: Array<Object>) {
    const selectedItems = items.map(item => {
      return type === "object" ? { id: item } : item;
    });

    props.onChange(selectedItems);
  }

  const disabledValue =
    selected().reduce((acc, item, idx) => {
      if (idx === selected().length - 1) return acc + `${item.label}`;
      return acc + `${item.label}, `;
    }, "") || "N/A";

  return props.disabled ? (
    <div className="schema-form-text-input">
      <input disabled className="form-control fs-14" value={disabledValue} />
    </div>
  ) : (
    <ComboBox
      isMulti
      onChange={handleChange}
      value={selected()}
      options={options}
      disabled={props.disabled}
      readOnly={props.readonly}
      id="multi-select"
      className={props.className}
    />
  );
}

export default localize()(MultiSelectField);
